module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('c-navbar'), _vm._v(" "), _c('c-content', [(_vm.listDatas.length > 0) ? _c('c-cell-container', {
    directives: [{
      name: "scroll-load",
      rawName: "v-scroll-load"
    }],
    staticClass: "mg-0"
  }, _vm._l((_vm.listDatas), function(item, index) {
    return _c('c-cell', {
      key: index,
      staticClass: "cell-item",
      class: item.orderStatusType,
      attrs: {
        "icon": item.orderIcon,
        "title": item.orderTitle,
        "desc": item.orderStatus
      },
      nativeOn: {
        "click": function($event) {
          _vm.itemClick(item, index)
        }
      }
    })
  })) : _c('div', {
    staticClass: "empty"
  }, [_vm._v("\n        暂无订单记录\n      ")])], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-right",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c5157d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/about-me/order-detail/index.vue
// module id = 1058
// module chunks = 2